import { Loader } from '@spotted-zebra-uk/ui-components';
import styles from './page-loader.module.scss';

export const PageLoader = () => {
  return (
    <div className={styles.pageLoader}>
      <Loader variant="bubbles" />
    </div>
  );
};
